import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { reduxForm } from "redux-form";

import { Message, Radio, Popup, Image } from "semantic-ui-react";
import { ModalTemplate, Button, Loading, ReduxFormMaterialSwitch } from "components";
import fileDownload from "js-file-download";
import * as examLib from "libs/examLib";

import styles from "../../../style/modal.css";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

class ModalDownloadReport extends Component {
  state = {
    loading: false,
    reportType: 0,
    reportEnable: false,
    groupExamNo: null,
    groupReportEnable: false,
    warningMessage: "",
  };

  componentDidMount() {
    const { selectedExamSummaryNo, selectedExamList, examSummaryByExamNo } = this.props;

    if (selectedExamSummaryNo === "all") {
      // 통합, 개별
      if (selectedExamList.size > 0) {
        let parentsNoData = {};

        selectedExamList.toJS().map((examNo) => {
          const examData = examSummaryByExamNo.get(String(examNo));
          const parentsNo = examData && examData.get("parentsExamNo");
          if (!!parentsNo) {
            if (typeof parentsNoData[parentsNo] === "undefined") {
              parentsNoData[parentsNo] = 0;
            }
            parentsNoData[parentsNo] += 1;
          }
        });

        const parentsKeys = parentsNoData ? Object.keys(parentsNoData) : [];
        this.setState({
          reportEnable: true,
          groupExamNo: parentsKeys[0],
          groupReportEnable: selectedExamList.size > 1 && parentsKeys.length === 1 && parentsNoData[parentsKeys[0]] === selectedExamList.size,
        });
      }
    } else {
      // 개별
      this.setState({
        reportEnable: true,
      });
    }
  }

  // 보고서 유형 선택 이벤트
  onChangeReportType = (e, { value }) => {
    this.setState({
      reportType: value,
      warningMessage: "",
    });
  };

  // 다운로드 버튼 클릭 이벤트
  onDownloadReport = () => {
    const { formStore, selectedExamSummaryNo, selectedExamList, examSummaryByExamNo, onToggleModal } = this.props;
    const { formatMessage } = this.props.intl;
    const { reportType, reportEnable, groupExamNo, groupReportEnable } = this.state;

    // 다운로드 API 호출 및 파일 다운로드
    const reportFileDownload = async (examNoParam, reportTarget) => {
      this.setState({ loading: true });

      let reportParam = {
        examNoArray: examNoParam,
      };

      // 마스킹이 활성화된 것만 파라미터에 추가
      if (formStore && formStore.values) {
        Object.keys(formStore.values).map((key) => {
          if (formStore.values[key] === "1") {
            reportParam[key] = 1;
          }
        });
      }

      const examName = reportTarget ? examSummaryByExamNo.getIn([reportTarget, "examName"]) : "";
      let reportName = "";
      if (reportType === 3) {
        reportName = examName + defineMessages(formatMessage({ id: "CtExamHeader_2", defaultMessage: "훈련_보고서.xlsx" }));
        reportParam["csv"] = 1;
      } else {
        reportName = examName + defineMessages(formatMessage({ id: "CtExamHeader_1", defaultMessage: "_훈련_보고서.xlsx" }));
      }

      const respObj = await examLib.downloadExamReport(reportParam);
      if (respObj && respObj.data) {
        fileDownload(respObj.data, reportName);

        this.setState({ loading: false });
        onToggleModal("");
      }
    };

    try {
      if (reportType === 0 && (reportEnable || groupReportEnable)) {
        this.setState({
          warningMessage: defineMessages(formatMessage({ id: "ExamHeader_42", defaultMessage: "보고서 유형을 선택하세요" })),
        });
      }
      // 개별 보고서
      else if (reportType === 1 && reportEnable) {
        // 사이드바에서 전체훈련 선택 시
        if (selectedExamSummaryNo === "all") {
          // 선택한 보고서 여러 개일 때 각각 다운로드
          for (let i = 0; i < selectedExamList.size; i++) {
            reportFileDownload(JSON.stringify([selectedExamList.get(i)]), JSON.stringify(selectedExamList.get(i)));
          }
        } else {
          // 사이드바에서 개별 훈련 선택 시
          reportFileDownload(JSON.stringify([selectedExamSummaryNo]), JSON.stringify(selectedExamSummaryNo));
        }
      }
      // 통합 보고서
      else if (reportType === 2 && groupReportEnable) {
        reportFileDownload(JSON.stringify(selectedExamList), groupExamNo);
      }
      // CSV 보고서
      else if (reportType === 3 && reportEnable) {
        if (selectedExamSummaryNo === "all") {
          reportFileDownload(JSON.stringify(selectedExamList), null);
        } else {
          reportFileDownload(JSON.stringify([selectedExamSummaryNo]), JSON.stringify(selectedExamSummaryNo));
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      onToggleModal("");
      console.log("report download", error);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, onToggleModal } = this.props;
    const { loading, reportType, reportEnable, groupReportEnable, warningMessage } = this.state;
    const { onChangeReportType, onDownloadReport } = this;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx("modal-download-report", "common-content")}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: "ExamHeader_38", defaultMessage: "보고서 다운로드" }))}
        buttons={
          <div className={cx("inline-block")}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal("");
              }}
            >
              {defineMessages(formatMessage({ id: "ExamTemplateEditModal_4", defaultMessage: "취소" }))}
            </Button>
            <Button className={cx("brand-button")} disabled={loading || !!warningMessage} loading={loading} onClick={onDownloadReport}>
              {defineMessages(formatMessage({ id: "ExamHeader_39", defaultMessage: "다운로드" }))}
            </Button>
          </div>
        }
      >
        <div className={cx("modal-content")}>
          <Loading active={loading} size="small" content="Waiting..." />
          <div className={cx("template-detail")}>
            <div className="item-title">{defineMessages(formatMessage({ id: "ExamHeader_40", defaultMessage: "보고서 유형" }))}*</div>
            <div className="item-contents">
              <div className="radio-area">
                <Radio
                  className="report-radio"
                  label={defineMessages(formatMessage({ id: "ExamHeader_31", defaultMessage: "개별 보고서" }))}
                  name="radioGroup"
                  value={1}
                  checked={reportType === 1}
                  onChange={onChangeReportType}
                  disabled={!reportEnable}
                />
                <Popup
                  className="report-popup"
                  position="right center"
                  trigger={<Image className={cx("ml-5")} src="/img/examStart/btn_qmark.png" />}
                  content={defineMessages(formatMessage({ id: "ExamHeader_10", defaultMessage: "훈련 결과 '보고서'를 엑셀 파일로 다운로드" }))}
                />
              </div>
              <div className="radio-area">
                <Radio
                  className="report-radio"
                  label={defineMessages(formatMessage({ id: "ExamHeader_24", defaultMessage: "통합 보고서" }))}
                  name="radioGroup"
                  value={2}
                  checked={reportType === 2}
                  onChange={onChangeReportType}
                  disabled={!groupReportEnable}
                />
                <Popup
                  className="report-popup"
                  position="right center"
                  trigger={<Image className={cx("ml-5")} src="/img/examStart/btn_qmark.png" />}
                  content={
                    groupReportEnable
                      ? defineMessages(formatMessage({ id: "ExamHeader_23", defaultMessage: '"통합 훈련 보고서" 다운로드 (그룹 훈련만 통합이 가능합니다.)' }))
                      : defineMessages(
                          formatMessage({
                            id: "ExamHeader_32",
                            defaultMessage: "2개 이상의 '그룹 훈련'을 선택하세요",
                          })
                        )
                  }
                />
              </div>
              <div className="radio-area">
                <Radio
                  className="report-radio"
                  label={defineMessages(formatMessage({ id: "ExamHeader_37", defaultMessage: "CSV 보고서" }))}
                  name="radioGroup"
                  value={3}
                  checked={reportType === 3}
                  onChange={onChangeReportType}
                  disabled={!reportEnable}
                />
                <Popup
                  className="report-popup"
                  position="right center"
                  trigger={<Image className={cx("ml-5")} src="/img/examStart/btn_qmark.png" />}
                  content={defineMessages(formatMessage({ id: "ExamHeader_10", defaultMessage: "훈련 결과 '보고서'를 엑셀 파일로 다운로드" }))}
                />
              </div>
            </div>
            {warningMessage && <div className="warning-message">{warningMessage}</div>}

            <div className="item-title">{defineMessages(formatMessage({ id: "ExamHeader_41", defaultMessage: "마스킹 사용" }))}</div>
            <div className="item-contents">
              <div className="switch">
                <span>{defineMessages(formatMessage({ id: "TargetDetail_21", defaultMessage: "이름" }))}</span>
                <ReduxFormMaterialSwitch className={cx("input-switch")} name="maskingName" />
              </div>
              <div className="switch">
                <span>{defineMessages(formatMessage({ id: "TargetDetail_22", defaultMessage: "이메일" }))}</span>
                <ReduxFormMaterialSwitch className={cx("input-switch")} name="maskingEmail" />
              </div>
              <div className="switch">
                <span>{defineMessages(formatMessage({ id: "TargetDetail_23", defaultMessage: "연락처" }))}</span>
                <ReduxFormMaterialSwitch className={cx("input-switch")} name="maskingPhone" />
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formStore: state.form["downloadReport"],
    selectedExamSummaryNo: state.currentStatus.getIn(["examSummary", "selected"]),
    selectedExamList: state.currentStatus.getIn(["examList", "selected", "noArray"]),
    examSummaryByExamNo: state.examSummary.get("examSummaryByExamNo"),
  };
};

export default connect(
  mapStateToProps,
  null
)(
  reduxForm({
    form: "downloadReport",
    enableReinitialize: true,
    touchOnChange: true,
  })(injectIntl(ModalDownloadReport))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalDownloadReport.js